import { Component, OnInit } from '@angular/core';
import { LanguageService } from 'src/app/services/language.service';

@Component({
    selector: 'app-profile-builder-help',
    templateUrl: './profile-builder-help.component.html',
    styleUrls: ['./profile-builder-help.component.scss'],
    standalone: false
})
export class ProfileBuilderHelpComponent implements OnInit {

  constructor(public languageService:LanguageService) { }

  ngOnInit(): void {
  }

}
